// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon
module.exports.IconClose = function IconClose (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","transform":"scale(1.25)"},"child":[{"tag":"title","attr":{}},{"tag":"polygon","attr":{"id":"fill-color","points":"19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12"}}]})(props);
};
